import { createSelector, createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";

const slice = createSlice({
    name: "dashboard",
    initialState: {
        loading: false,
        lastFetch: null,
        allIssue: 0,
        forwardedIssue: 0,
        fixedIssue: 0,
        clientRpt: []
    },
    reducers: {
        allIssuesCount: (dashboard, action) => {
            dashboard.allIssue = action.payload;
        },
        forwardedIssuesCount: (dashboard, action) => {
            dashboard.forwardedIssue = action.payload;
        },
        fixedIssueCount: (dashboard, action) => {
            dashboard.fixedIssue = action.payload;
        },
        clientRptReceived: (dashboard, action) => {
            dashboard.clientRpt = action.payload;
        },

    }
});

export const { allIssuesCount, forwardedIssuesCount,
    fixedIssueCount, clientRptReceived } = slice.actions;
export default slice.reducer;

const getAllIssueCount = "dashboard/allIssueCount";
const getFixedIssueCount = "dashboard/fixedIssueCount";
const getForwardedIssueCount = "dashboard/forwardedIssueCount";
const getClientIssuesReport = "dashboard/clientIssuesReport";

export const loadAllIssueCount = () => apiCallBegan({
    url: getAllIssueCount,
    onSuccess: allIssuesCount.type
});

export const loadForwardedIssueCount = () => apiCallBegan({
    url: getForwardedIssueCount,
    onSuccess: forwardedIssuesCount.type
});
export const loadClientIssuesReport = () => apiCallBegan({
    url: getClientIssuesReport,
    onSuccess: clientRptReceived.type
});

export const loadFixedIssueCount = () => apiCallBegan({
    url: getFixedIssueCount,
    onSuccess: fixedIssueCount.type
});

export const getIssueCount = createSelector(
    state => state.entities.dashboard,
    dashboard => dashboard.allIssue
)

export const getFixedCount = createSelector(
    state => state.entities.dashboard,
    dashboard => dashboard.fixedIssue
)

export const getDevOpsCount = createSelector(
    state => state.entities.dashboard,
    dashboard => dashboard.forwardedIssue
)

export const getAllClientIssueRpt = createSelector(
    state => state.entities.dashboard,
    dashboard => dashboard.clientRpt
)